export const environment = {
  production: true,
  backEndUrl: "https://backend-dot-goreply-credem-spazio-test.oa.r.appspot.com",
  analytics: null,
  recaptcha: '6Le434whAAAAALEu4gbmWL2is7-nsKhaM2F6-LOW'
};
